import { gtmDatakey } from '@utils/GoogleTagManager';
import clsx from 'clsx';
import isEqual from 'lodash.isequal';
import Button from 'react-bootstrap/Button';
import { useDispatch } from 'react-redux';
import { ComponentName } from '../../../constants';
import { ThemeSettings } from '../../../constants';
import { useConfig } from '../../../hooks/useConfig';
import useGTM from '../../../hooks/useGTM';
import { useI18n } from '../../../hooks/useI18n';
import { useModal } from '../../../hooks/useModal';
import { setCookies } from '../../../state/reducers/config';
import { Cookies } from '../../../types/Config';

const CookieConsent = () => {
  const { enableModal, activeModal } = useModal();
  const { jsxT, t } = useI18n();
  const sendDataToGTM = useGTM();
  const dispatch = useDispatch();
  const { icons: icon } = ThemeSettings!;
  const { cookies } = useConfig((prev, next) =>
    isEqual(prev.cookies, next.cookies),
  );

  const handleAccept = () => {
    dispatch(
      setCookies(
        Object.keys(cookies).reduce((obj, id) => {
          obj[id] = true;
          return obj;
        }, {}) as Cookies,
      ),
    );
    sendDataToGTM({
      event: 'cookiePreferencesChange',
      [gtmDatakey('cookies.analytics')]: true,
      [gtmDatakey('cookies.functional')]: true,
      [gtmDatakey('cookies.marketing')]: true,
      [gtmDatakey('cookies.personalization')]: true,
    });
  };

  if (cookies.accepted) return null;
  return (
    <nav
      className={clsx(
        'cookies-nav',
        activeModal === ComponentName.CookiesModal && 'd-none',
      )}
    >
      <i className={clsx(icon?.cookies, 'cookies-nav__icon')}></i>
      <div className="cookies-nav__body">
        <h3 className="cookies-nav__body-title">{t('cookies_nav_title')}</h3>
        <p className="cookies-nav__body-text">
          {jsxT('cookie_consent_desc')} {jsxT('cookie_consent_open_policy')}
        </p>
      </div>
      <div className="cookies-nav__buttons">
        <Button
          size="sm"
          variant="outline-light"
          onClick={() => enableModal(ComponentName.CookiesModal)}
        >
          {t('cookies_modal_button')}
        </Button>
        <Button
          size="sm"
          id="gdpr-snackbar-accept"
          variant="primary"
          onClick={handleAccept}
        >
          {t('cookie_consent_accept')}
        </Button>
      </div>
    </nav>
  );
};

export default CookieConsent;
